import { Column } from "pdfmake/interfaces";
import { RegisteredChipDetailResponse } from "@app/shared/models/chip-details.model";

export function addSignatures(
  registrationDetails: RegisteredChipDetailResponse
): Column[] {
  const columns: Column[] = [
    {
      width: '*',
      stack: [
        { text: 'Nënshkrimi i Veterinerit', margin: [0, 20, 0, 5] },
        {
          image: registrationDetails.veterinarianSignature,
          width: 50,
          height: 50,
        },
      ],
    },
  ];

  if (registrationDetails.previousOwnerSignature) {
    columns.push({
      width: '*',
      stack: [
        { text: 'Pronari i mëparshëm', margin: [0, 20, 0, 5] },
        {
          image: registrationDetails.previousOwnerSignature,
          width: 50,
          height: 50,
        },
      ],
    });
  }

  columns.push({
    width: '*',
    stack: [
      { text: 'Pronari', margin: [0, 20, 0, 5] },
      {
        image: registrationDetails.ownerSignature,
        width: 50,
        height: 50,
      },
    ],
  });

  return columns;
}
